import React from 'react'
import renderHTML from 'react-render-html'
import moment from 'moment'
import auth from '../../modules/auth'

// Import Scss
import './Message.scss'

// Import Images
import maleAvatar from '../../images/default-account-profile.png'
import femaleAvatar from '../../images/default-account-profile-female.png'


import {
  convertLineBreaksToHtml,
  convertPlainUrlToATag
} from '../../modules/formatting'

const reformatTime = (time) => {
  const today = moment()
  const yesterday = moment().subtract(1, 'day')
  const momentTime = moment(time)
  if (momentTime.isSame(today, 'day')) return momentTime.format("今日 HH:mm")
  if (momentTime.isSame(yesterday, 'day')) return momentTime.format("昨日 HH:mm")
  return momentTime.format("YYYY年MM月DD日HH:mm")
}

const message = (props) => {
  let content = convertLineBreaksToHtml(props.message.content)
  content = convertPlainUrlToATag(content)
  const genderOriginCustomer = auth.getCustomerInfoBy('gender')
  let avatarCustomer
  let baseClassName = `message ${props.className}`
  if (genderOriginCustomer === "male") {
    avatarCustomer = maleAvatar
  } else {
    avatarCustomer = femaleAvatar
  }

  if(props.isMyself) {
    baseClassName = `message myself ${props.className}`
  }

  return(
    <div className={baseClassName}>
      <div className="media floating-support-chat__item">
        <div className="floating-support-chat__item__avatar align-self-start mr-3">
          <img alt="avatar"
            src={props.message.member_avatar === null ? avatarCustomer : props.message.member_avatar}
          />
        </div>
        <div className="media-body floating-support-chat__item__content">
          <h5 className="floating-support-chat__item__name mt-0">
            {props.message.member_name}
          </h5>
          <div className="floating-support-chat__item__message">
            <p>
              {
                renderHTML(content)
              }
            </p>
          </div>
          <div className="floating-support-chat__item__time">
            <span>{reformatTime(props.message.created_at)}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default message



// WEBPACK FOOTER //
// ./src/components/Message/Message.js